var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"preview",attrs:{"src":_vm.post.previewPic}})}
var staticRenderFns = []

export { render, staticRenderFns }